export default "__VITE_ASSET__DZv2q7RL__"